const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth/mcp.authorize.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { clearMcpAuthorization, rememberMcpAuthorization } from '@/features/authentication/lib/mcpAuthorizationIntent';
import { mcpAuthorizationSearch } from '@/features/authentication/types/mcpAuthorization';
import { LOGIN_ROUTE, waitForAuth } from '@/shared/lib/authSession';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/mcp/authorize')({
  validateSearch: mcpAuthorizationSearch,
  beforeLoad: async ({
    search
  }) => {
    const user = await waitForAuth();
    if (!user) {
      rememberMcpAuthorization(search.request);
      throw redirect({
        to: LOGIN_ROUTE
      });
    }
    if (!user.emailVerified) {
      rememberMcpAuthorization(search.request);
      throw redirect({
        to: '/login-complete'
      });
    }
    clearMcpAuthorization();
    return {
      mcpUser: user
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});